export default __webpack_public_path__ + "static/media/head-logo.82e3f945.jpg";